export const safeModeLabel = "Q3GSvb";
export const recoveryModeLabel = "CWfUZc";
export default {safeModeLabel,recoveryModeLabel};